import React from "react";
import { ContactForm } from "../ContactUsSections/ContactForm";
import { ContactUsBanner } from "../ContactUsSections/ContactUsBanner";
import './contactUs.scss'
const ContactUsContent = (props) => {
  return (
    <div className="cotactUs">
      <ContactUsBanner />
      <ContactForm />
    </div>
  );
};
export default ContactUsContent;
